import { Backdrop } from '../../components/Backdrop/Backdrop';
import FilterRadioItem from '../../components/FilterItem/FilterRadioItem';
import type { FilterSection } from '../../components/SearchFilterBar/SearchFilterBar';
import { palette } from '../../theme/colors';
import type { CreateMessageReplyType } from '../../utils/enums';
import { translate } from '../../utils/translate';
import { SFilter, SHeader, SLabel } from './MessageTypeFilter.styles';

type MessageFilterProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleTypeChange: (id: CreateMessageReplyType & number) => void;
  filters: FilterSection;
};

const MessageTypeFilter = (props: MessageFilterProps) => {
  const { isOpen, setIsOpen, handleTypeChange, filters } = props;

  if (!isOpen) return <></>;

  return (
    <>
      <SFilter role="messageTypeFilter">
        <SHeader role="header">
          <rect width="400" height="100" fill={palette.silver} />
        </SHeader>
        <SLabel role="title">{translate(filters.title ?? 'messages_selectReplyType')}:</SLabel>
        <ul>
          {filters.content.map((option, key2) => (
            <FilterRadioItem
              checked={option.checked}
              name={option.name}
              setSelected={() => {
                handleTypeChange(option.id as number & CreateMessageReplyType);
              }}
              key={key2}
              id={option.id}
            />
          ))}
        </ul>
      </SFilter>
      <Backdrop setModal={setIsOpen} />
    </>
  );
};

export default MessageTypeFilter;
